import { render, staticRenderFns } from "./AddTestimonial.vue?vue&type=template&id=88cc83b2&scoped=true&"
import script from "./AddTestimonial.vue?vue&type=script&lang=js&"
export * from "./AddTestimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cc83b2",
  null
  
)

export default component.exports